import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import PermissionGuard from "../../components/auth/PermissionGuard";

export default function MenusPage() {
  const [menus, setMenus] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [form, setForm] = useState({
    code: "",
    parent_id: "",
    name: "",
    icon: "",
    route_path: "",
    component_key: "",
    menu_group: "",
    sort_order: 0,
    permission_code: "",
    is_visible: true,
    is_active: true,
  });

  async function loadData() {
    const [menusRes, permissionsRes] = await Promise.all([
      axios.get("/admin/menus"),
      axios.get("/admin/permissions"),
    ]);

    setMenus(menusRes.data?.data || []);
    setPermissions(permissionsRes.data?.data || {});
  }

  useEffect(() => {
    loadData();
  }, []);

  async function handleCreate(e) {
    e.preventDefault();

    await axios.post("/admin/menus", {
      ...form,
      parent_id: form.parent_id || null,
      sort_order: Number(form.sort_order || 0),
      permission_code: form.permission_code || null,
    });

    setForm({
      code: "",
      parent_id: "",
      name: "",
      icon: "",
      route_path: "",
      component_key: "",
      menu_group: "",
      sort_order: 0,
      permission_code: "",
      is_visible: true,
      is_active: true,
    });

    await loadData();
  }

  const permissionOptions = Object.values(permissions).flat();

  return (
    <PermissionGuard permission="security.menus.view">
      <div>
        <h2>Menus</h2>

        <form
          onSubmit={handleCreate}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: 12,
            background: "#fff",
            padding: 16,
            borderRadius: 12,
            marginBottom: 24,
          }}
        >
          <input
            placeholder="Code"
            value={form.code}
            onChange={(e) => setForm((prev) => ({ ...prev, code: e.target.value }))}
          />
          <input
            placeholder="Name"
            value={form.name}
            onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
          />
          <input
            placeholder="Icon"
            value={form.icon}
            onChange={(e) => setForm((prev) => ({ ...prev, icon: e.target.value }))}
          />

          <input
            placeholder="Route Path"
            value={form.route_path}
            onChange={(e) => setForm((prev) => ({ ...prev, route_path: e.target.value }))}
          />
          <input
            placeholder="Component Key"
            value={form.component_key}
            onChange={(e) => setForm((prev) => ({ ...prev, component_key: e.target.value }))}
          />
          <input
            placeholder="Menu Group"
            value={form.menu_group}
            onChange={(e) => setForm((prev) => ({ ...prev, menu_group: e.target.value }))}
          />

          <input
            placeholder="Sort Order"
            type="number"
            value={form.sort_order}
            onChange={(e) => setForm((prev) => ({ ...prev, sort_order: e.target.value }))}
          />

          <select
            value={form.parent_id}
            onChange={(e) => setForm((prev) => ({ ...prev, parent_id: e.target.value }))}
          >
            <option value="">No Parent</option>
            {menus.map((menu) => (
              <option key={menu.id} value={menu.id}>
                {menu.name}
              </option>
            ))}
          </select>

          <select
            value={form.permission_code}
            onChange={(e) => setForm((prev) => ({ ...prev, permission_code: e.target.value }))}
          >
            <option value="">No Permission</option>
            {permissionOptions.map((permission) => (
              <option key={permission.id} value={permission.code}>
                {permission.code}
              </option>
            ))}
          </select>

          <button type="submit">Create Menu</button>
        </form>

        <div style={{ background: "#fff", padding: 16, borderRadius: 12 }}>
          <table width="100%" cellPadding="8">
            <thead>
              <tr>
                <th align="left">Name</th>
                <th align="left">Code</th>
                <th align="left">Route</th>
                <th align="left">Parent</th>
                <th align="left">Permission</th>
              </tr>
            </thead>
            <tbody>
              {menus.map((menu) => (
                <tr key={menu.id}>
                  <td>{menu.name}</td>
                  <td>{menu.code}</td>
                  <td>{menu.route_path}</td>
                  <td>{menu.parent_id || "-"}</td>
                  <td>{menu.permission_code || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </PermissionGuard>
  );
}
